function parseType(value, attribute) {
  if (value === undefined || value === null) {
    return value;
  }
  const {
    trueDisplayValue,
    falseDisplayValue
  } = attribute?.blueprint?.attribute?.model || {};
  switch (attribute.valueType) {
    case 'string':
      return value;
    case 'int':
      return Number(value);
    case 'number':
      return Number(value);
    case 'percent':
      return Number(value);
    case 'boolean':
      if (value.toLowerCase() === trueDisplayValue?.toLowerCase() || value.toLowerCase() === 'true') {
        return true;
      }
      if (value.toLowerCase() === falseDisplayValue?.toLowerCase() || value.toLowerCase() === 'false') {
        return false;
      }
      return value;
    // eslint-disable-next-line no-restricted-globals
    case 'timestamp':
      return !isNaN(new Date(value)) ? new Date(value) : value;
    case 'geoPoint':
      {
        try {
          const val = JSON.parse(value);
          return val;
        } catch (err) {
          return null;
        }
      }
    case 'geoJson':
      return value;
    default:
      return Number.isNaN(Number(value)) ? value : Number(value);
  }
}
export default {
  parseType
};